import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BankAccountTransactionExport  {
    _originalTypeClassName = "zERP.BO.BankAccountTransactionExport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BankAccountTransactionExport.translate = translateService;
}
this.Date = null;
this.Reference = null;
this.Description = null;
this.Deposit = null;
this.Withdraw = null;
this.ProgressiveDeposit = null;
this.ProgressiveWithdraw = null;
this.Remaining = null;
this.BankAccountTransactionExportKey = null;
this._key = this.BankAccountTransactionExportKey = 0; 
}

static translate: TranslateService;
_key: any;
Date:any;
Reference:any;
Description:any;
Deposit:any;
Withdraw:any;
ProgressiveDeposit:any;
ProgressiveWithdraw:any;
Remaining:any;
private _BankAccountTransactionExportKey:any;
get BankAccountTransactionExportKey(): any {
    return this._BankAccountTransactionExportKey;
  }
set BankAccountTransactionExportKey(value: any) {
    this._BankAccountTransactionExportKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.BankAccountTransactionExportKey == null || $this.BankAccountTransactionExportKey == 0;
            }


}